import * as yup from "yup";

export const strongPasswordValidation = yup
  .string()
  .required("Este campo é obrigatório")
  .min(8, "A senha deve ter pelo menos 8 caracteres")
  .matches(/\d/, "A senha deve conter pelo menos um número")
  .matches(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula")
  .matches(/[a-z]/, "A senha deve conter pelo menos uma letra minúscula")
  .matches(/[!@#$%^&*(),.?":{}|<>_]/, "A senha deve conter pelo menos um símbolo");